import React from "react";
import { FileViewerContext } from ".";

function useFileViewerContext() {
  const context = React.useContext(FileViewerContext);

  return context;
}

export default useFileViewerContext;
